export default __webpack_public_path__ + "static/media/img-59.3a76062f.jpg";